var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNftMenu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 5.1891V16.8365C20 17.2541 19.6611 17.593 19.2435 17.593H11.5036C11.0859 17.593 10.7471 17.2541 10.7471 16.8365V16.6489H14.949C15.633 16.6489 16.1925 16.0894 16.1925 15.4054V4.43262H19.2435C19.6611 4.43262 20 4.77147 20 5.1891Z",
    fill: "#4D5B7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25289 16.6489V16.8427C9.25289 17.2616 8.91529 17.5992 8.49015 17.5992H0.756486C0.338856 17.5992 0 17.2604 0 16.8427V5.19533C0 4.7777 0.338856 4.43884 0.756486 4.43884H3.81369V15.4023C3.81369 16.0906 4.37199 16.6489 5.06033 16.6489H9.25289Z",
    fill: "#4D5B7C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99383 2.60144H13.9744C14.424 2.60144 14.7891 2.96655 14.7891 3.41607V14.5758C14.7891 15.0253 14.424 15.3898 13.9751 15.3898H5.99383C5.54431 15.3898 5.1792 15.0247 5.1792 14.5752V3.41607C5.1792 2.96655 5.54431 2.60144 5.99383 2.60144Z",
    fill: "var(--gray-40)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76495 0.0187558L7.75244 0H7.75869C7.75869 0.00625195 7.75869 0.0125039 7.76495 0.0187558Z",
    fill: "var(--gray-40)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2164 0L12.2039 0.0187558C12.2101 0.0125039 12.2101 0.00625195 12.2101 0H12.2164Z",
    fill: "var(--gray-40)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNftMenu);
export default __webpack_public_path__ + "static/media/Nft-menu.eedc3a8366eb3a1aaaa5afc736d51ae7.svg";
export { ForwardRef as ReactComponent };